import React, { useEffect, useState } from 'react';
import { WorkflowInputLayout } from './WorkflowInputLayout';
import { getMdhdWorkflowConfig, updateMdhdWorkflowConfig } from '../../../utils/mdhdWorkflowConfig';

export default function EvChargingBehaviorInputPage() {
  const behaviorConfig = getMdhdWorkflowConfig().evChargingBehavior;
  const [socInitial, setSocInitial] = useState(behaviorConfig.socInitial);
  const [socMax, setSocMax] = useState(behaviorConfig.socMax);
  const [socMin, setSocMin] = useState(behaviorConfig.socMin);
  const [socThreshold, setSocThreshold] = useState(behaviorConfig.socThreshold);

  useEffect(() => {
    updateMdhdWorkflowConfig('evChargingBehavior', {
      socInitial,
      socMax,
      socMin,
      socThreshold,
    });
  }, [socInitial, socMax, socMin, socThreshold]);

  return (
    <WorkflowInputLayout title="EV Charging Behavior">
      <div className="bg-white rounded-xl shadow-lg font-nunito p-6">
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Charging behavior assumptions</h2>
          <p className="text-sm text-gray-600 mt-1">
            Configure battery state-of-charge thresholds used by MDHD charging feasibility logic.
          </p>
        </div>

        <div className="border rounded-lg p-4 bg-gray-50">
          <label className="block text-sm font-semibold text-gray-800 mb-3">State of charge thresholds</label>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Initial SoC (0-1)</label>
              <input
                type="number"
                min={0}
                max={1}
                step={0.01}
                value={socInitial}
                onChange={(e) => setSocInitial(e.target.value)}
                className="w-full rounded border border-gray-200 px-2.5 py-1.5 text-sm text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Start-of-week state of charge.</p>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Maximum SoC (0-1)</label>
              <input
                type="number"
                min={0}
                max={1}
                step={0.01}
                value={socMax}
                onChange={(e) => setSocMax(e.target.value)}
                className="w-full rounded border border-gray-200 px-2.5 py-1.5 text-sm text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Upper charging bound.</p>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Minimum SoC (0-1)</label>
              <input
                type="number"
                min={0}
                max={1}
                step={0.01}
                value={socMin}
                onChange={(e) => setSocMin(e.target.value)}
                className="w-full rounded border border-gray-200 px-2.5 py-1.5 text-sm text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Routes below this are infeasible.</p>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">SoC threshold (0-1)</label>
              <input
                type="number"
                min={0}
                max={1}
                step={0.01}
                value={socThreshold}
                onChange={(e) => setSocThreshold(e.target.value)}
                className="w-full rounded border border-gray-200 px-2.5 py-1.5 text-sm text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">Enroute charging trigger level.</p>
            </div>
          </div>
        </div>
      </div>
    </WorkflowInputLayout>
  );
}
